/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiHealthPingResponse {
  clientId: string;
  krbName?: string;
  impersonated?: string;
  referred?: string;
  scopes?: string[];
}

export interface ApiHealthStatusResponse {
  items: ApiHealthStatusItem[];
  stage: string;
}

export interface ApiHealthStatusItem {
  name: string;
  status: string;
  message?: string;
}

export interface PaymentPreferences {
  employeeId: string;
  paymentAccounts: PaymentAccount[];
  reimbursementAccount?: PaymentAccount | null;
  payrollEmail?: boolean;
  reimbursementEmail?: boolean;
  pernr?: string;
  message?: string;
}

export interface PaymentPreferencesUpdate {
  paymentAccounts: PaymentAccount[];
  reimbursementAccount?: PaymentAccount | null;
  payrollEmail?: boolean;
  reimbursementEmail?: boolean;
  /** Duo authorization code from 2FA authentication */
  duoCode?: string | null;
  /** State parameter from Duo authentication */
  state?: string | null;
}

export interface PaymentAccount {
  accountType: "CHECKING" | "SAVINGS";
  /** @pattern ^[0-9]{9}$ */
  routingNumber: string;
  accountNumber: string;
  /**
   * @min 0
   * @max 100
   */
  percentage: number;
  /**
   * Fixed dollar amount for direct deposit when not using percentage-based allocation
   * @min 0
   */
  amount?: number | null;
  bankName?: string | null;
  /** @default true */
  isActive?: boolean;
  /** @default false */
  isMain?: boolean;
  addressType?: string | null;
  paymentMethod?:
    | "C"
    | "F"
    | "G"
    | "K"
    | "L"
    | "M"
    | "T"
    | "W"
    | "X"
    | "Y"
    | "Z";
  lastChanged?: string | null;
  changedBy?: string | null;
}

export interface SecurityField {
  fieldName: "SSN" | "DOB";
  fieldType: "TEXT" | "DATE";
  required: boolean;
  label?: string;
  hint?: string;
}

export interface Address {
  addressLine1: string;
  addressLine2?: string | null;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  buildingCode?: string | null;
  roomNumber?: string | null;
}

export interface DuoAuthRequest {
  action: string;
  redirectUrl?: string;
}

export interface DuoAuthResponse {
  authUrl?: string;
  state?: string;
}

export interface PlaidCreateLinkTokenRequest {
  /** User ID (optional, will be derived from headers if not provided) */
  userId?: string | null;
}

export interface PlaidCreateLinkTokenResponse {
  /** Plaid Link token for client-side initialization */
  linkToken: string;
  /**
   * Token expiration timestamp
   * @format date-time
   */
  expiration: string;
}

export interface PlaidExchangePublicTokenRequest {
  /** Public token received from Plaid Link */
  publicToken: string;
}

export interface PlaidExchangePublicTokenResponse {
  /** Access token for API calls */
  accessToken: string;
  /** Plaid Item ID */
  itemId: string;
}

export interface PlaidAccountsRequest {
  /** Plaid access token */
  accessToken: string;
}

export interface PlaidAccountsResponse {
  accounts: PlaidAccount[];
  item: PlaidItem;
  requestId: string;
}

export interface PlaidAccount {
  accountId: string;
  balances: PlaidAccountBalance;
  mask: string;
  name: string;
  officialName?: string | null;
  subtype: string;
  type: string;
}

export interface PlaidAccountBalance {
  available?: number | null;
  current?: number | null;
  isoCurrencyCode?: string | null;
  limit?: number | null;
  unofficialCurrencyCode?: string | null;
}

export interface PlaidAuthRequest {
  /** Plaid access token */
  accessToken: string;
}

export interface PlaidAuthResponse {
  accounts: PlaidAccount[];
  numbers: PlaidAuthNumbers;
  item: PlaidItem;
  requestId: string;
}

export interface PlaidAuthNumbers {
  ach: PlaidAuthNumber[];
  eft: PlaidAuthNumber[];
  international: PlaidAuthNumber[];
  bacs: PlaidAuthNumber[];
}

export interface PlaidAuthNumber {
  /** Account number */
  account: string;
  /** Plaid account ID */
  accountId: string;
  /** Routing number */
  routing: string;
  /** Wire routing number */
  wireRouting?: string | null;
}

export interface PlaidInstitutionRequest {
  /** Plaid institution ID */
  institutionId: string;
}

export interface PlaidInstitutionResponse {
  institution: PlaidInstitution;
  requestId: string;
}

export interface PlaidInstitution {
  institutionId: string;
  name: string;
  products: string[];
  countryCodes: string[];
  url?: string | null;
  primaryColor?: string | null;
  logo?: string | null;
  routingNumbers: string[];
  oauth: boolean;
}

export interface PlaidItem {
  availableProducts: string[];
  billedProducts: string[];
  /** @format date-time */
  consentExpirationTime?: string | null;
  error?: PlaidError | null;
  institutionId: string;
  itemId: string;
  webhook: string;
  updateType: string;
}

export interface PlaidError {
  errorType: string;
  errorCode: string;
  errorMessage: string;
  displayMessage?: string | null;
  requestId: string;
  causes: string[];
  status: number;
  documentationUrl: string;
  suggestedAction?: string | null;
}

export interface DuoUniversalCallbackRequest {
  /** State parameter from Duo authentication */
  state?: string;
  /** Duo authorization code */
  duoCode: string;
  /** Original redirect URL used during authentication initiation */
  redirectUrl?: string;
}

export interface DuoUniversalCallbackResponse {
  /** Whether the authentication was successful */
  success: boolean;
  /** Authenticated username */
  username?: string | null;
  authResult?: DuoAuthResult | null;
  /** Error message if authentication failed */
  error?: string | null;
}

export interface DuoAuthResult {
  sub: string;
  preferred_username: string;
  aud: string;
  iss: string;
  exp: number;
  iat: number;
  auth_time: number;
  auth_context: DuoAuthContext;
}

export interface DuoAuthContext {
  access_device: DuoAccessDevice;
  application: DuoApplication;
  auth_device: DuoAuthDevice;
  factor: string;
  result: string;
  reason?: string | null;
  timestamp: number;
  txid: string;
  user: DuoUser;
}

export interface DuoAccessDevice {
  browser: string;
  browser_version: string;
  flash_version?: string | null;
  hostname: string;
  ip: string;
  is_encryption_enabled: boolean;
  is_firewall_enabled: boolean;
  is_password_set: boolean;
  java_version?: string | null;
  location: DuoLocation;
  os: string;
  os_version: string;
  security_agents?: string[] | null;
}

export interface DuoApplication {
  key: string;
  name: string;
}

export interface DuoAuthDevice {
  ip?: string | null;
  location?: DuoLocation | null;
  name: string;
}

export interface DuoLocation {
  city: string;
  country: string;
  state: string;
}

export interface DuoUser {
  groups: string[];
  key: string;
  name: string;
}

export interface DuoHealthResponse {
  /** Overall health status */
  status: "healthy" | "unhealthy";
  /** Whether Duo API is accessible */
  duoApi: boolean;
  /** Whether Duo configuration is valid */
  configValid: boolean;
  /**
   * Health check timestamp
   * @format date-time
   */
  timestamp: string;
  /** Error message if unhealthy */
  error?: string | null;
}

export interface Init {
  /** Whether to show the primary account */
  showPrimaryAccount?: boolean;
  /** Whether to show the reimbursement account */
  showReimbursementAccount?: boolean;
  /** Whether to show secondary accounts */
  showSecondaryAccount?: boolean;
  /** Whether to hide all accounts */
  hideBankAccounts?: boolean;
  useStripe?: boolean;
  stripePublicKey?: string;
  /** Initialization message */
  message?: string;
}

export interface StripeCreateSessionRequest {
  /** Data permissions to request (optional, defaults to ["payment_method"]) */
  permissions?: (
    | "payment_method"
    | "balances"
    | "ownership"
    | "transactions"
  )[];
  /** Data to prefetch upon account creation (optional, defaults to ["balances"]) */
  prefetch?: ("balances" | "ownership" | "transactions")[];
  /** Return URL for webview integrations (optional) */
  returnUrl?: string;
}

export interface StripeCreateSessionResponse {
  /** Unique session identifier */
  sessionId: string;
  /** Client secret for frontend integration */
  clientSecret: string;
  /** Account holder information */
  accountHolder?: object;
  /** Granted permissions */
  permissions: string[];
  /** Applied filters */
  filters?: object;
  /** Prefetched data types */
  prefetch?: string[];
}

export interface StripeRetrieveSessionRequest {
  /** Session identifier to retrieve */
  sessionId: string;
}

export interface StripeRetrieveSessionResponse {
  /** Session identifier */
  sessionId: string;
  /** Client secret */
  clientSecret: string;
  /** Account holder information */
  accountHolder?: object;
  /** Session permissions */
  permissions?: string[];
  /** Applied filters */
  filters?: object;
  /** Prefetched data */
  prefetch?: string[];
  /** Connected accounts */
  accounts?: StripeAccount[];
}

export interface StripeRetrieveAccountRequest {
  /** Financial Connections account ID */
  accountId: string;
}

export interface StripeRetrieveAccountResponse {
  /** Account identifier */
  accountId: string;
  /** Account category */
  category: "cash" | "credit" | "investment" | "other";
  /** Account subcategory */
  subcategory: string;
  /** Display name of the account */
  displayName?: string | null;
  /** Last four digits of the account */
  lastFour?: string | null;
  /** Name of the financial institution */
  institutionName: string;
  /** Balance refresh status */
  balanceRefresh?: object | null;
  /** Ownership refresh status */
  ownershipRefresh?: object | null;
  /** Transaction refresh status */
  transactionRefresh?: object | null;
  balance?: {
    /** Current balance */
    current?: number;
    /** Available balance */
    available?: number;
    /** Currency code */
    currencyCode?: string;
  } | null;
  ownership?: {
    owners?: {
      name?: string;
      email?: string | null;
      addresses?: {
        line1?: string;
        line2?: string | null;
        city?: string;
        state?: string;
        postalCode?: string;
        country?: string;
      }[];
    }[];
  };
}

export interface StripeAccount {
  /** Account identifier */
  accountId: string;
  /** Account category */
  category: "cash" | "credit" | "investment" | "other";
  /** Account subcategory */
  subcategory: string;
  /** Display name */
  displayName?: string | null;
  /** Last four digits */
  lastFour?: string | null;
  /** Institution name */
  institutionName: string;
  /** Balance refresh status */
  balanceRefresh?: object | null;
  /** Ownership refresh status */
  ownershipRefresh?: object | null;
  /** Transaction refresh status */
  transactionRefresh?: object | null;
}

export interface StripeAccountNumbersResponse {
  /** Bank account number */
  accountNumber: string;
  /** Bank routing number */
  routingNumber: string;
  /** Name of the financial institution */
  institutionName: string;
  /** Type of account */
  accountType: "checking" | "savings";
  /** Display name of the account */
  displayName: string;
  /** Last four digits of the account */
  lastFour: string;
}

export interface StripeCreateSetupIntentRequest {
  /** Return URL for webview integrations (optional) */
  returnUrl?: string;
}

export interface StripeCreateSetupIntentResponse {
  /** Unique SetupIntent identifier */
  setupIntentId: string;
  /** Client secret for frontend integration */
  clientSecret: string;
  /** SetupIntent status */
  status: string;
  /** Stripe customer ID */
  customerId: string;
}

export interface StripeConfirmSetupIntentRequest {
  /** SetupIntent identifier to confirm */
  setupIntentId: string;
}

export interface StripeConfirmSetupIntentResponse {
  /** SetupIntent identifier */
  setupIntentId: string;
  /** SetupIntent status */
  status: string;
  /** Attached payment method ID */
  paymentMethodId?: string | null;
  /** Payment method details including bank account information */
  paymentMethod?: {
    /** Payment method ID */
    id?: string;
    /** Payment method type */
    type?: string;
    usBankAccount?: {
      /** Account holder type */
      accountHolderType?: string;
      /** Account type (checking/savings) */
      accountType?: string;
      /** Bank name */
      bankName?: string;
      /** Account fingerprint */
      fingerprint?: string;
      /** Last 4 digits of account */
      last4?: string;
      /** Bank routing number */
      routingNumber?: string;
    } | null;
  };
}

export interface BankInfoResponse {
  /**
   * Name of the bank
   * @example "JPMorgan Chase"
   */
  bankName: string;
  /**
   * Pre-signed URL to the bank logo
   * @format uri
   * @example "https://s3.amazonaws.com/bank-logos/logos/chase.png?..."
   */
  logoUrl?: string;
  /**
   * Bank routing number
   * @example "021000021"
   */
  routingNumber?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://global.api.mit.edu/direct-deposit/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title direct-deposit-api
 * @version 0.1
 * @baseUrl https://global.api.mit.edu/direct-deposit/v1
 */
export class DirectDepositApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  apiHealth = {
    /**
     * @description Is the API reachable
     *
     * @tags meta
     * @name PingList
     * @request GET:/api-health/ping
     */
    pingList: (params: RequestParams = {}) =>
      this.request<ApiHealthPingResponse, any>({
        path: `/api-health/ping`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Can the API connect to all the various integrations that it should be able to
     *
     * @tags meta
     * @name StatusList
     * @request GET:/api-health/status
     */
    statusList: (params: RequestParams = {}) =>
      this.request<ApiHealthStatusResponse, any>({
        path: `/api-health/status`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  duo = {
    /**
     * @description Initiate Duo 2FA authentication
     *
     * @tags direct-deposit, duo
     * @name AuthCreate
     * @request POST:/duo/auth
     * @secure
     */
    authCreate: (data: DuoAuthRequest, params: RequestParams = {}) =>
      this.request<DuoAuthResponse, void>({
        path: `/duo/auth`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle Duo Universal authentication callback
     *
     * @tags duo
     * @name CallbackCreate
     * @request POST:/duo/callback
     * @secure
     */
    callbackCreate: (
      data: DuoUniversalCallbackRequest,
      params: RequestParams = {},
    ) =>
      this.request<DuoUniversalCallbackResponse, void>({
        path: `/duo/callback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Duo service health check
     *
     * @tags duo, meta
     * @name HealthList
     * @request GET:/duo/health
     */
    healthList: (params: RequestParams = {}) =>
      this.request<DuoHealthResponse, DuoHealthResponse>({
        path: `/duo/health`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  init = {
    /**
     * @description Init Check
     *
     * @tags direct-deposit
     * @name InitList
     * @request GET:/init
     * @secure
     */
    initList: (params: RequestParams = {}) =>
      this.request<Init, any>({
        path: `/init`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  metadata = {
    /**
     * @description AsyncAPI JSON File that describes the API
     *
     * @tags meta
     * @name AsyncapiList
     * @request GET:/metadata/asyncapi
     */
    asyncapiList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/metadata/asyncapi`,
        method: "GET",
        ...params,
      }),

    /**
     * @description OpenAPI JSON File that describes the API
     *
     * @tags meta
     * @name OpenapiList
     * @request GET:/metadata/openapi
     */
    openapiList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/metadata/openapi`,
        method: "GET",
        ...params,
      }),
  };
  paymentPreferences = {
    /**
     * @description Get user payment preferences
     *
     * @tags direct-deposit
     * @name PaymentPreferencesList
     * @request GET:/payment-preferences
     * @secure
     */
    paymentPreferencesList: (params: RequestParams = {}) =>
      this.request<PaymentPreferences, void>({
        path: `/payment-preferences`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update user payment preferences
     *
     * @tags direct-deposit
     * @name PaymentPreferencesUpdate
     * @request PUT:/payment-preferences
     * @secure
     */
    paymentPreferencesUpdate: (
      data: PaymentPreferencesUpdate,
      params: RequestParams = {},
    ) =>
      this.request<PaymentPreferences, void>({
        path: `/payment-preferences`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  banks = {
    /**
     * @description Get bank logo from S3 storage
     *
     * @tags direct-deposit, bank-logo
     * @name LogosDetail
     * @request GET:/banks/logos/{bankName}
     * @secure
     */
    logosDetail: (bankName: string, params: RequestParams = {}) =>
      this.request<BankInfoResponse, void>({
        path: `/banks/logos/${bankName}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get bank information by routing number
     *
     * @tags direct-deposit, banks
     * @name InfoDetail
     * @request GET:/banks/info/{routingNumber}
     * @secure
     */
    infoDetail: (routingNumber: string, params: RequestParams = {}) =>
      this.request<BankInfoResponse, void>({
        path: `/banks/info/${routingNumber}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  plaid = {
    /**
     * @description Get user bank accounts from Plaid
     *
     * @tags plaid
     * @name AccountsCreate
     * @request POST:/plaid/accounts
     * @secure
     */
    accountsCreate: (data: PlaidAccountsRequest, params: RequestParams = {}) =>
      this.request<PlaidAccountsResponse, void>({
        path: `/plaid/accounts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get authentication data for bank accounts (routing/account numbers)
     *
     * @tags plaid
     * @name AuthCreate
     * @request POST:/plaid/auth
     * @secure
     */
    authCreate: (data: PlaidAuthRequest, params: RequestParams = {}) =>
      this.request<PlaidAuthResponse, void>({
        path: `/plaid/auth`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create Plaid Link token for bank account connection
     *
     * @tags plaid
     * @name CreateLinkTokenCreate
     * @request POST:/plaid/create-link-token
     * @secure
     */
    createLinkTokenCreate: (
      data: PlaidCreateLinkTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlaidCreateLinkTokenResponse, void>({
        path: `/plaid/create-link-token`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Exchange Plaid public token for access token
     *
     * @tags plaid
     * @name ExchangePublicTokenCreate
     * @request POST:/plaid/exchange-public-token
     * @secure
     */
    exchangePublicTokenCreate: (
      data: PlaidExchangePublicTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlaidExchangePublicTokenResponse, void>({
        path: `/plaid/exchange-public-token`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get institution information by ID
     *
     * @tags plaid
     * @name InstitutionCreate
     * @request POST:/plaid/institution
     * @secure
     */
    institutionCreate: (
      data: PlaidInstitutionRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlaidInstitutionResponse, void>({
        path: `/plaid/institution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  stripe = {
    /**
     * @description Create a new Stripe Financial Connections session for account linking. A Stripe customer will be automatically created using the authenticated user ID. Default permissions are ["payment_method"] and default prefetch is ["balances"].
     *
     * @tags stripe
     * @name CreateSessionCreate
     * @request POST:/stripe/create-session
     * @secure
     */
    createSessionCreate: (
      data: StripeCreateSessionRequest,
      params: RequestParams = {},
    ) =>
      this.request<StripeCreateSessionResponse, void>({
        path: `/stripe/create-session`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve Stripe Financial Connections session details including linked accounts
     *
     * @tags stripe
     * @name RetrieveSessionCreate
     * @request POST:/stripe/retrieve-session
     * @secure
     */
    retrieveSessionCreate: (
      data: StripeRetrieveSessionRequest,
      params: RequestParams = {},
    ) =>
      this.request<StripeRetrieveSessionResponse, void>({
        path: `/stripe/retrieve-session`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve detailed information about a specific Financial Connections account
     *
     * @tags stripe
     * @name RetrieveAccountCreate
     * @request POST:/stripe/retrieve-account
     * @secure
     */
    retrieveAccountCreate: (
      data: StripeRetrieveAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<StripeRetrieveAccountResponse, void>({
        path: `/stripe/retrieve-account`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get account and routing numbers for direct deposit setup
     *
     * @tags stripe
     * @name AccountNumbersCreate
     * @request POST:/stripe/account-numbers
     * @secure
     */
    accountNumbersCreate: (
      data: {
        /** The Financial Connections account ID */
        accountId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StripeAccountNumbersResponse, void>({
        path: `/stripe/account-numbers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new Stripe SetupIntent for single account selection via Financial Connections. This provides an alternative flow to session-based linking for users who want to select only one account. A Stripe customer will be automatically created using the authenticated user ID.
     *
     * @tags stripe
     * @name CreateSetupIntentCreate
     * @request POST:/stripe/create-setup-intent
     * @secure
     */
    createSetupIntentCreate: (
      data: StripeCreateSetupIntentRequest,
      params: RequestParams = {},
    ) =>
      this.request<StripeCreateSetupIntentResponse, void>({
        path: `/stripe/create-setup-intent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve confirmed SetupIntent details including the attached payment method with bank account information
     *
     * @tags stripe
     * @name ConfirmSetupIntentCreate
     * @request POST:/stripe/confirm-setup-intent
     * @secure
     */
    confirmSetupIntentCreate: (
      data: StripeConfirmSetupIntentRequest,
      params: RequestParams = {},
    ) =>
      this.request<StripeConfirmSetupIntentResponse, void>({
        path: `/stripe/confirm-setup-intent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
